/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';

export interface ChargeLevelIconProps {
  size?: IconSize | number;
  color?: string;
  outlineColor?: string;
}

/*
 * Defines the Design Language System (DLS) Charge Level Icon component.
 */
export const ChargeLevelIcon = ({
  size = 18,
  color,
  outlineColor = dlsColor('white')
}: ChargeLevelIconProps) => {
  return (
    <ThemeIconProvider name='ChargeLevelIcon' size={size} color={color} legacyIcon={(
      <svg width={size} height={size} viewBox="0 0 18 16" fill="none">
        <path d="M14.5 3H1.5C1.22386 3 1 3.22386 1 3.5V11.5C1 11.7761 1.22386 12 1.5 12H14.5C14.7761 12 15 11.7761 15 11.5V11C15 10.7239 15.2239 10.5 15.5 10.5H16.5C16.7761 10.5 17 10.2761 17 10V5C17 4.72386 16.7761 4.5 16.5 4.5H15.5C15.2239 4.5 15 4.27614 15 4V3.5C15 3.22386 14.7761 3 14.5 3Z" stroke={outlineColor}/>
        <path d="M1 3C6.46734 3 13.25 3 15 3V12H1V3Z" fill={outlineColor}/>
        <path fillRule="evenodd" clipRule="evenodd" d="M13.1672 4C13.4434 4 13.6672 4.22386 13.6672 4.5L13.6672 10.5C13.6672 10.7761 13.4434 11 13.1672 11L2.5 11C2.22386 11 2 10.7761 2 10.5L2 4.5C2 4.22386 2.22386 4 2.5 4L13.1672 4ZM12.499 4.99164L12.499 5.16681L12.499 5.34164L12.499 9.6583L12.499 9.83347L12.499 10.0083L2.99024 10.0083L2.99024 4.99164L12.499 4.99164ZM12.1577 9.6583L12.1577 5.34164L3.34026 5.34164L3.34026 9.6583L12.1577 9.6583Z" fill={color}/>
        <path d="M15 4.5L17 5V10L15 10.5V4.5Z" fill={outlineColor}/>
        <rect x="16" y="5" width="5" height="1" transform="rotate(90 16 5)" fill={color}/>
      </svg>
    )} />
  );
};
